import { graphql } from '@generated/gql';

export const FETCH_PORTFOLIO_OPTIMIZER_RAN_AT = graphql(/** GraphQL */ `
  query portfolioOptimizerBreadcrumbFetchPortfolioOptimizerRanAt(
    $input: FetchPortfolioOptimizerInput!
  ) {
    fetchPortfolioOptimizer(input: $input) {
      portfolioOptimizer {
        createdAt
      }
    }
  }
`);
